import { render, staticRenderFns } from "./trainingModulePageNew10.vue?vue&type=template&id=2fcb6f7f&scoped=true&"
import script from "./trainingModulePageNew10.vue?vue&type=script&lang=js&"
export * from "./trainingModulePageNew10.vue?vue&type=script&lang=js&"
import style0 from "./trainingModulePageNew10.vue?vue&type=style&index=0&id=2fcb6f7f&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fcb6f7f",
  null
  
)

export default component.exports